module.exports = __webpack_public_path__ + "img/(4).d0e8172a.jpg";